import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Title from '@zenbusiness/common-components/Title';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const StyledSectionRoot = styled('section')(({ theme }) => ({
  paddingTop: theme.spacing(2)
}));

export const StyledCard = styled(Card)(() => ({
  width: '100%',
  borderRadius: 16
}));

export const StyledGridDomainHead = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(6)
}));

export const StyledPageTitle = styled(Title)(({ theme }) => ({
  ...theme.typography.title_extraLarge
}));

export const StyledGridQuickSelectTitle = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3, 3.5, 0)
}));

export const StyledCardQuickSelectContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  margin: '0 auto',
  padding: theme.spacing(3, 4, 2)
}));

export const StyledCardActionsQuickSelectAction = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2, 4, 3.75)
}));

export const StyledSharedAssetHintsIcon = styled(SharedAsset)(({ theme }) => ({
  padding: theme.spacing(0, 1, 3, 1),
  maxWidth: '100%',
  margin: 'auto'
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container, & .MuiPaper-root': {
    borderRadius: '15px',
    paddingLeft:  theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      height: '484px',
      position: 'absolute',
      left: 0,
      bottom: 0,
      margin: theme.spacing(0),
      borderBottomLeftRadius: '0',
      borderBottomRightRadius: '0'
    }
  }
}));

export const StyledDialogHeader = styled('section')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    height: '75px'
  },
  height: '61px'
}));

export const StyledDialogTitle = styled(Title)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: '400',
  paddingTop: theme.spacing(0)
}));

export const StyledDialogButtonGroup = styled(DialogActions)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    paddingBottom: theme.spacing(0)
  },
  justifyContent: 'center',
  '& >:not(:first-of-type)': {
    marginLeft: theme.spacing(3)
  }
}));

export const StyledDialogButtons = styled(Button)(({ theme }) => ({
  boxShadow: 'none',
  [theme.breakpoints.up('md')]: {
    height: '64px',
    padding: theme.spacing(3, 4)
  },
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(5)
  },
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
    borderRadius: 0
  }
}));

export const StyledButton = styled(Button)(() => ({
  width: '100%',
  display: 'block',
  textAlign: 'center',
  margin: '0 auto',
  textTransform: 'none'
}));

export const StyledButtonWide = styled(Button)(({ theme }) => ({
  lineHeight: '24px',
  textTransform: 'none',
  padding: theme.spacing(2, 6),
  borderRadius: 16,
  width: '100%'
}));

export const StyledButtonClose = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500]
}));
